"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.EngageStats = void 0;
const operationTracking_1 = require("./operationTracking");
const ResponseError_1 = require("./ResponseError");
class EngageStats extends operationTracking_1.OperationStats {
    static getTryCatchFinallyHook(_ctx) {
        const msgSender = _ctx.funcThis;
        return msgSender?.statsClient;
    }
    constructor(actionPerformer) {
        super();
        this.actionPerformer = actionPerformer;
        this._tags = [];
    }
    onTry(ctx) {
        const res = super.onTry(ctx);
        const parentOperation = ctx.parent;
        if (parentOperation) {
            const operation_path = this.getOperationNameTag(parentOperation);
            if (operation_path)
                ctx.tags.push('operation_path:' + operation_path);
        }
        return res;
    }
    get statsClient() {
        return this.actionPerformer.executeInput.statsContext?.statsClient;
    }
    get tags() {
        if (this.actionPerformer.currentOperation?.tags)
            return this.actionPerformer.currentOperation.tags;
        if (this.actionPerformer.executeInput.statsContext?.tags)
            return this.actionPerformer.executeInput.statsContext?.tags;
        return this._tags;
    }
    stats(statsArgs) {
        if (!this.statsClient)
            return;
        const { method: statsMethod, metric, value, tags } = statsArgs;
        let statsFunc = this.statsClient?.[statsMethod || 'incr'].bind(this.statsClient);
        if (!statsFunc)
            switch (statsMethod ||
                'incr') {
                case 'incr':
                    statsFunc = this.statsClient?.incr.bind(this.statsClient);
                    break;
                case 'histogram':
                    statsFunc = this.statsClient?.histogram.bind(this.statsClient);
                    break;
                case 'set':
                    statsFunc = this.statsClient?.set.bind(this.statsClient);
                    break;
                default:
                    break;
            }
        statsFunc?.(`${this.actionPerformer.getIntegrationStatsName()}.${metric}`, typeof value === 'undefined' ? 1 : value, this.mergeTags(this.actionPerformer.executeInput.statsContext?.tags, tags));
    }
    incr(metric, value, tags) {
        this.stats({ metric, value, tags, method: 'incr' });
    }
    histogram(metric, value, tags) {
        this.stats({ metric, value, tags, method: 'histogram' });
    }
    set(metric, value, tags) {
        this.stats({ metric, value, tags, method: 'set' });
    }
    extractTagsFromError(error, ctx) {
        const res = super.extractTagsFromError(error, ctx);
        const errDetails = (0, ResponseError_1.getErrorDetails)(error);
        if (errDetails?.code)
            res.push(`error_code:${errDetails.code}`);
        if (errDetails?.status)
            res.push(`error_status:${errDetails.status}`);
        if (error.underlyingError) {
            const underlyingErrorTags = this.extractTagsFromError(error.underlyingError, ctx);
            res.push(...underlyingErrorTags.map((t) => `underlying_${t}`));
        }
        return res;
    }
    getOperationNameTag(ctx) {
        if (!ctx)
            return undefined;
        return this.actionPerformer.logger.getOperationName(ctx, true, '::');
    }
}
exports.EngageStats = EngageStats;
//# sourceMappingURL=EngageStats.js.map